module.exports = __webpack_public_path__ + "static/media/Medium_to_Long.14a0676b.svg";